import * as React from 'react';
import axios from 'axios';
import { Table } from 'antd';
import dayjs from 'dayjs';

type Appointments = {
  appointments: Object[] | undefined;
};

type Company = {
  companyName: string;
  companyCode: string;
};

export default function AppointmentsTable(props: Appointments) {
  const [companies, setCompanies] = React.useState([]);
  const [appointments, setAppointments] = React.useState([]);
  const [appointmentsUpdated, setAppointmentsUpdated] = React.useState(false);

  console.log(appointments);

  React.useEffect(() => {
    // Get all the companies
    axios.get('/api/company').then((res) => {
      setCompanies(res.data);
    });
  }, [props.appointments]);

  // Within the appointments array, if there is a coupon, add the associated company as well
  React.useEffect(() => {
    if (props.appointments && props?.appointments?.length > 0) {
      const newAppointments: any = props.appointments.map((appointment: any) => {
        if (appointment.couponUsed) {
          let foundCompany: any = companies.find(
            (company: Company) => company.companyCode.toUpperCase() === appointment.couponUsed.toUpperCase()
          );

          if (foundCompany?.companyName) {
            appointment.company = foundCompany.companyName;
          }
        }
        return appointment;
      });
      setAppointments(newAppointments);
    }
  }, [companies]);

  const columns: Object[] = [
    {
      title: 'Order ID',
      dataIndex: 'orderId',
      render: (text: string, record: any) => {
        return (
          <a
            href={`https://www.pacificrimsafety.ca/wp-admin/post.php?post=${record.orderId}&action=edit`}
            target="_blank"
            rel="noreferrer"
          >
            {text}
          </a>
        );
      },
    },
    {
      title: 'Course Name',
      dataIndex: 'appointmentName',
    },
    {
      title: 'Date Booked',
      dataIndex: 'appointmentDate',
      render: (text: string, record: any) => {
        return dayjs(text).format('MMM DD, YYYY');
      },
    },
    {
      title: 'Company',
      dataIndex: 'company',
      render: (text: string, record: any) => {
        if (record.company) {
          return record.company;
        }
      },
    },
  ];

  return (
    <>
      {appointments.length > 0 ? <Table columns={columns} dataSource={appointments} rowKey="_id" /> : <>Loading...</>}
    </>
  );
}
